import axios from 'services/axios'
import localStorageService from 'services/storage'
import { clearTermsAcknowledged } from 'components/TermsAndConditionsModal/utils'

const logoutRequest = () => axios.get('auth/logout')

export const handleLogout = () => {
  clearTermsAcknowledged()
  // IVX-11142 — drop the boot-wave hint so the next load of this browser fires
  // currentUser alone rather than five calls that can only 401.
  localStorageService.clearSession()
  logoutRequest().then(res => {
    window.location.href = `${res.data.logoutUrl}?id_token_hint=${res.data.idToken}&post_logout_redirect_uri=${window.location.origin}`
  })
}
